import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const businessTypes = [
  { text: "your restaurant", color: "text-amber-400" },
  { text: "your law firm", color: "text-blue-400" },
  { text: "your clinic", color: "text-emerald-400" },
  { text: "your auto shop", color: "text-red-400" },
  { text: "your real estate agency", color: "text-purple-400" },
  { text: "your retail store", color: "text-cyan-400" },
];

export default function TypewriterText() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [displayText, setDisplayText] = useState("");
  const [isDeleting, setIsDeleting] = useState(false);

  useEffect(() => {
    const currentBusiness = businessTypes[currentIndex].text;
    
    const timeout = setTimeout(() => {
      if (!isDeleting) {
        // Typing
        if (displayText.length < currentBusiness.length) {
          setDisplayText(currentBusiness.slice(0, displayText.length + 1));
        } else {
          // Pause at full text, then start deleting
          setTimeout(() => setIsDeleting(true), 2000);
        }
      } else {
        // Deleting
        if (displayText.length > 0) {
          setDisplayText(displayText.slice(0, -1));
        } else {
          setIsDeleting(false);
          setCurrentIndex((prev) => (prev + 1) % businessTypes.length);
        }
      }
    }, isDeleting ? 50 : 100);

    return () => clearTimeout(timeout);
  }, [displayText, isDeleting, currentIndex]);

  return (
    <div className="inline-flex items-center">
      <span className={`${businessTypes[currentIndex].color} font-bold`}>
        {displayText}
      </span>
      <motion.span
        className="inline-block w-0.5 h-8 ml-1 bg-blue-400"
        animate={{ opacity: [1, 0] }}
        transition={{ duration: 0.5, repeat: Infinity, repeatType: "reverse" }}
      />
    </div>
  );
}

